(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerWrapper = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      
      if (this.headerIsAlwaysSticky) {
        this.classList.add('shopify-section-header-sticky');
      }

      // Add dynamic body padding adjustment
      this.adjustBodyPadding();
      window.addEventListener('resize', this.adjustBodyPadding.bind(this));
      window.addEventListener('load', this.adjustBodyPadding.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    // Function to adjust body padding based on actual header height
    adjustBodyPadding() {
      // Wait for layout to complete
      setTimeout(() => {
        const headerHeight = this.offsetHeight;
        document.body.style.paddingTop = `${headerHeight}px`;
      }, 100);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Additional script to ensure body padding gets updated properly
  document.addEventListener('DOMContentLoaded', function() {
    // Initial adjustment
    adjustBodyPaddingGlobal();
    
    // Also adjust after a delay to account for any layout shifts
    setTimeout(adjustBodyPaddingGlobal, 500);
    setTimeout(adjustBodyPaddingGlobal, 1000);
  });

  function adjustBodyPaddingGlobal() {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = `${headerHeight}px`;
    }
  }

  // Adjust padding when window is resized
  window.addEventListener('resize', function() {
    adjustBodyPaddingGlobal();
  });

  // Mobile menu toggle functionality
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.querySelector('.mobile-menu-button');
    const mobileDropdown = document.querySelector('#mobile-dropdown');
    
    if (mobileMenuButton && mobileDropdown) {
      mobileMenuButton.addEventListener('click', function() {
        // Toggle active class on button for animation
        mobileMenuButton.classList.toggle('active');
        
        // Toggle active class on dropdown to show/hide
        mobileDropdown.classList.toggle('active');
      });

      // Close mobile menu when clicking on a link
      const mobileLinks = mobileDropdown.querySelectorAll('a');
      mobileLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          mobileMenuButton.classList.remove('active');
          mobileDropdown.classList.remove('active');
        });
      });

      // Close mobile menu when clicking outside
      document.addEventListener('click', function(event) {
        if (!mobileMenuButton.contains(event.target) && !mobileDropdown.contains(event.target)) {
          mobileMenuButton.classList.remove('active');
          mobileDropdown.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const headerOffset = 220;

  function offsetAnchorScroll() {
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target) {
        const scrollPosition = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
      }
    }
  }

  // Handle page load with hash
  window.addEventListener("load", () => {
    setTimeout(offsetAnchorScroll, 0);
  });

  // Handle hashchange (clicking internal links)
  window.addEventListener("hashchange", () => {
    setTimeout(offsetAnchorScroll, 0);
  });

  // Handle direct anchor link clicks for smooth scrolling
  const anchorLinks = document.querySelectorAll('.privacy-toc a[href^="#"], .related-pages-list a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.hash = this.getAttribute('href');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
